import { RouteObject } from "react-router-dom";
import {
  HOME_CATEGORY_DETAIL,
  HOME_CATEGORY_FREELANCER,
  HOME_CATEGORY_FREELANCER_DETAILS,
  HOME_FREELANCER_DETAILS,
} from "constants/urls";

export default [
  {
    index: true,
    lazy: () => import("modules/home/pages/Home"),
  },
  {
    path: HOME_CATEGORY_DETAIL,
    lazy: () => import("modules/home/pages/HomeCategoryDetails"),
  },
  {
    path: HOME_CATEGORY_FREELANCER,
    lazy: () => import("modules/home/pages/HomeCategoryFreelancerList"),
  },
  {
    path: HOME_CATEGORY_FREELANCER_DETAILS,
    lazy: () => import("modules/home/pages/HomeFreelancerDetails"),
  },
  {
    path: HOME_FREELANCER_DETAILS,
    lazy: () => import("modules/home/pages/HomeFreelancerDetails"),
  },
] as RouteObject[];
